const dartsScoringData = [
    ['everything else'], //0
    [9, 10, 25, 26, 41, 42, 57, 73, 88], //1
    [153, 169, 186, 202, 203, 204, 219, 220, 221, 235, 236], //2
    [184, 199, 200, 215, 216, 231, 232, 247, 248], //3
    [61, 62, 75, 76, 77, 78, 91, 92, 106], //4
    [5, 6, 21, 22, 37, 38, 54, 70, 71, 87], //5
    [123, 124, 125, 126, 127, 139, 140, 141, 142, 143], //6
    [166, 180, 181, 195, 196, 197, 210, 211, 212, 227, 228], //7
    [133, 144, 145, 146, 147, 148, 160, 161, 162], //8
    [49, 50, 51, 65, 66, 67, 68, 83, 84, 85, 101], //9
    [138, 155, 156, 157, 158, 159, 173, 174, 175], //10
    [112, 113, 114, 115, 116, 128, 129, 130, 131, 132], //11
    [20, 35, 36, 52, 53, 68, 69, 85, 86], //12
    [93, 94, 95, 107, 108, 109, 110, 111, 122], //13
    [80, 81, 82, 96, 97, 98, 99, 100, 117], //14
    [154, 170, 171, 172, 187, 188, 189, 190, 205, 206], //15
    [149, 163, 164, 165, 178, 177, 179, 193, 194], //16
    [168, 185, 201, 217, 218, 233, 234, 249], //17
    [27, 28, 38, 43, 44, 58, 59, 60, 74, 75, 89, 90, 105], //18
    [167, 182, 183, 198, 213, 214, 229, 230, 246], //19
    [7, 8, 23, 24, 39, 40, 55, 56], //20
    [103, 104, 118, 121, 134, 137, 151, 152], //Outer Bullseye
    [119, 120, 135, 136] //Bullseye
]

export default dartsScoringData